import React from 'react';

export const SendDrawerContext = React.createContext({});
